<template>
  <v-chart ref="chart" class="chart" :option="option" @click="click1"/>
</template>

<script>
export default {
  name: 'stackChart1',
  props: {
    avadata: Object,
    simpleavadata: Object,
    showDemo: String
  },
  data() {
    return {
      option: { },
      owndata: {}
    }
  },
  watch: {
    treemapdata: {
      handler(newValue, oldValue) {
        this.owndata = newValue
        this.getDataView()
      }
    }
  },
  mounted() {
    console.log('[stackChart/mounted]')
    this.$nextTick(() => {
      if (this.showDemo == 'true') {
        this.owndata = this.avadata
        this.getDataView()
      } else {
        this.owndata = this.simpleavadata
        setTimeout(() => {
          this.getDataView()
        }, 2000)
      }
    })
  },
  methods: {
    getDataView() {
      console.log('[stackChart/getDataView]');
      // this.axios.get('api/kcapi/get_sexandage').then((response) => {
      console.log(this.owndata)
      this.option = {
          title: {
            text: 'Download: SupplementalMaterials.docx', link:'./file/OSRI-SupplementalMaterials.docx',
            right:80, textStyle: { fontSize : 14, fontWeight : 'normal' },
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            //data: ['STLCs', 'China', 'EU27', 'Germany', 'India', 'Japan', 'Russia', 'UK', 'USA']
            data: ['China', 'EU27', 'Germany', 'India', 'Japan', 'Russia', 'STLCs', 'UK', 'USA']
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          toolbox: {
            feature: {
                myTool1: {
                    show: true,
                    title: '自定义扩展方法1',
                    //icon: 'path://M432.45,595.444c0,2.177-4.661,6.82-11.305,6.82c-6.475,0-11.306-4.567-11.306-6.82s4.852-6.812,11.306-6.812C427.841,588.632,432.452,593.191,432.45,595.444L432.45,595.444z M421.155,589.876c-3.009,0-5.448,2.495-5.448,5.572s2.439,5.572,5.448,5.572c3.01,0,5.449-2.495,5.449-5.572C426.604,592.371,424.165,589.876,421.155,589.876L421.155,589.876z M421.146,591.891c-1.916,0-3.47,1.589-3.47,3.549c0,1.959,1.554,3.548,3.47,3.548s3.469-1.589,3.469-3.548C424.614,593.479,423.062,591.891,421.146,591.891L421.146,591.891zM421.146,591.891',
                    //icon: 'path://M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z',
                    //icon: 'image://data:image/gif;base64,R0lGODlhEAAQAMQAAORHHOVSKudfOulrSOp3WOyDZu6QdvCchPGolfO0o/XBs/fNwfjZ0frl3/zy7////wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAkAABAALAAAAAAQABAAAAVVICSOZGlCQAosJ6mu7fiyZeKqNKToQGDsM8hBADgUXoGAiqhSvp5QAnQKGIgUhwFUYLCVDFCrKUE1lBavAViFIDlTImbKC5Gm2hB0SlBCBMQiB0UjIQA7',
                    onclick: function (){
                        alert('myToolHandler1')
                    }
                },
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: ['1996','1997','1998','1999','2000','2001','2002','2003','2004','2005','2006','2007','2008','2009','2010','2011','2012','2013','2014','2015','2016','2017','2018','2019','2020','2021','2022','2023']
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: 'STLCs',
              type: 'line',
              //stack: 'Total',
              data: [0.155,0.154,0.157,0.155,0.157,0.154,0.154,0.171,0.172,0.176,0.179,0.178,0.181,0.182,0.184,0.190,0.197,0.206,0.217,0.227,0.234,0.246,0.256,0.266,0.297,0.324,0.341,0.371]
            },
            {
              name: 'China',
              type: 'line',
              data: [0.150,0.153,0.154,0.155,0.159,0.159,0.165,0.178,0.186,0.199,0.202,0.202,0.220,0.224,0.234,0.252,0.298,0.298,0.317,0.342,0.373,0.391,0.432,0.473,0.535,0.583,0.672,0.680]
            },
            {
              name: 'EU27',
              type: 'line',
              data: [0.363,0.372,0.379,0.382,0.391,0.396,0.409,0.439,0.456,0.487,0.503,0.524,0.541,0.562,0.580,0.605,0.634,0.658,0.685,0.703,0.727,0.748,0.775,0.798,0.860,0.941,0.955,0.972]
            },
            {
              name: 'Germany',
              type: 'line',
              data: [0.283,0.289,0.299,0.296,0.297,0.300,0.305,0.320,0.327,0.343,0.347,0.355,0.358,0.367,0.374,0.382,0.391,0.401,0.406,0.417,0.428,0.439,0.453,0.469,0.513,0.558,0.571,0.602]
            },
            {
              name: 'India',
              type: 'line',
              data: [0.120,0.121,0.123,0.121,0.123,0.121,0.125,0.129,0.132,0.134,0.135,0.138,0.141,0.145,0.154,0.161,0.158,0.166,0.173,0.185,0.197,0.202,0.213,0.227,0.256,0.277,0.314,0.342]
            },
            {
              name: 'Japan',
              type: 'line',
              data: [0.174,0.177,0.177,0.178,0.184,0.183,0.186,0.198,0.200,0.205,0.211,0.212,0.215,0.223,0.225,0.231,0.237,0.244,0.250,0.258,0.269,0.278,0.295,0.311,0.350,0.384,0.401,0.428]
            },
            {
              name: 'Russia',
              type: 'line',
              data: [0.126,0.130,0.132,0.135,0.137,0.136,0.139,0.146,0.146,0.150,0.153,0.152,0.149,0.150,0.148,0.151,0.155,0.160,0.163,0.166,0.170,0.183,0.192,0.201,0.231,0.259,0.269,0.287]
            },
            {
              name: 'UK',
              type: 'line',
              data: [0.295,0.298,0.296,0.295,0.299,0.297,0.302,0.320,0.329,0.338,0.349,0.364,0.365,0.379,0.386,0.394,0.407,0.421,0.430,0.446,0.461,0.476,0.492,0.509,0.548,0.595,0.610,0.645]
            },
            {
              name: 'USA',
              type: 'line',
              data: [0.409,0.417,0.420,0.422,0.418,0.415,0.435,0.463,0.482,0.509,0.521,0.557,0.551,0.580,0.595,0.613,0.635,0.655,0.719,0.734,0.743,0.761,0.775,0.783,0.800,0.841,0.825,0.853]
            }
          ]
      }
      // }).catch((response) => {
      //   console.log(response)
      // })
      this.$refs['chart'].setOption(this.option);

    },
    resize() {
      this.$refs['chart'].resize()
    },

    click1(params){
        console.log('[stackChart1/click1]', params, params.name);
        //window.open('https://www.baidu.com/s?wd=' + encodeURIComponent(params.name));
        this.$emit('chgYear', params.name);
    }
  }
}
</script>

<style>

</style>
